export const EVENTS = {
  COMMING_SOON: {
    ACTION_REQUIRED: 'commingsoon.action.required',
  }
};
